const initialState = {
  newReferralSourceForm: false,
  orgId: '',
};
export default initialState;
